import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

/** Accordion without the hairline MUI draws above each collapsed panel. */
export const SeamlessAccordion = styled(Accordion)({
  '&:before': { display: 'none' },
});

/**
 * Summary at MUI's stock header height — the app-wide theme override shrinks it to match
 * small inputs — whose content lays out as one clipped space-between row.
 */
export const RowAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: theme.spacing(6),
  '&.Mui-expanded': { minHeight: theme.spacing(8) },
  '.MuiAccordionSummary-content': {
    overflow: 'hidden',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '0 !important',
    marginTop: '0 !important',
  },
}));
